import React from "react";
import TitleBar from "../../components/navbar/TitleBar";
import NavMenu from "../../components/navbar/NavMenu";
import ManageData from "../Managedata/managedata";
import ManageDataMain from "../../components/manageData/ManageDataMain";
import Footer from "../../components/common/Footer";
export default function ManageDataPage() {
  return (
    <>
      <TitleBar />
      <NavMenu />
      <ManageDataMain />
      <Footer />
    </>
  );
}
